import { ActionDefinition } from '../types'

/**
 * Declares the tracked actions of one area of the catalog. The keys are the action names sent
 * as X-Activity-Name: 2 to 5 PascalCase segments separated by dots ("Ime.Appointment.Save"),
 * at most 128 characters. Actions of a component shared between modules (src/components/*) have
 * no module prefix ("Payment.Save"): the module comes from the page's subject.
 *
 * ```ts
 * export const appointmentActions = defineActions({
 *   'Ime.Appointment.Save': { label: 'Save appointment', area: 'Appointment' },
 *   'Ime.Appointment.Cancel': { label: 'Cancel appointment', area: 'Appointment', enabled: false },
 * })
 * ```
 */
export const defineActions = <T extends Record<string, ActionDefinition>>(
  actions: T
): T => actions
